import { MutationTree } from 'vuex'

import ApiRequest from '@/core/ApiRequest'
import AccessModel from '@/core/models/AccessModel'
import { MenuGroup } from '@/core/models/Menu'
import RootState from '@/store/root/state'


export const SET_LOADING: string = 'setLoading'

export const SET_USER_DIALOG_SHOWN: string = 'setUserDialogShown'

export const SET_MENU_DIALOG_SHOWN: string = 'setMenuDialogShown'

export const SET_HISTORY_DIALOG_SHOWN: string = 'setHistoryDialogShown'

export const SET_ACCESS_MODEL = 'setAccessModel'

export const SET_API_REQUEST = 'setApiRequest'

export const SET_CALENDAR_LAST_DATE = 'setCalendarLastDate'

export const SET_CLIENT_LAST_SEARCH_QUERY = 'setClientLastSearchQuery'

/**
 * Sets is search loading flag state.
 */
export function setLoading (state: RootState, isLoading: boolean) {
  state.isLoading = isLoading
}

/**
 * Sets is user dialog shown flag state.
 */
export function setUserDialogShown (state: RootState, isUserDialogShown: boolean) {
  state.isUserDialogShown = isUserDialogShown
}

/**
 * Sets is menu dialog shown flag state.
 */
export function setMenuDialogShown (state: RootState, isMenuDialogShown: boolean) {
  state.isMenuDialogShown = isMenuDialogShown
}

/**
 * Sets is history dialog shown flag state.
 */
export function setHistoryDialogShown (state: RootState, isHistoryDialogShown: boolean) {
  state.isHistoryDialogShown = isHistoryDialogShown
}

/**
 * Sets accessModel.
 *
 * @param state   Root Vuex state.
 * @param model   Access model.
 */
export function setAccessModel (state: RootState, model: AccessModel | null) {
  state.accessModel = model
}

/**
 * Sets apiRequest.
 *
 * @param state     Root Vuex state.
 * @param instance  ApiRequest instance.
 */
export function setApiRequest (state: RootState, instance: ApiRequest) {
  state.apiRequest = instance
}

/**
 * Sets calendar last date state.
 */
export function setCalendarLastDate (state: RootState, lastDate: String | null) {
  state.calendarLastDate = lastDate
}

/**
 * Sets client last search query state.
 */
export function setClientLastSearchQuery (state: RootState, query: string) {
  state.clientLastSearchQuery = query
}

export default {
  setLoading,
  setAccessModel,
  setApiRequest,
  setUserDialogShown,
  setMenuDialogShown,
  setHistoryDialogShown,
  setCalendarLastDate,
  setClientLastSearchQuery,
} as MutationTree<RootState>
